<template>
  <p>Carregando...</p>
</template>

<script>
export default {
  name: "SlugHandler",

  mounted() {
    this.$store
      .dispatch("brandChannel/loadFromSlug", this.$route.fullPath)
      .then(path => {
        this.$store.dispatch("tracking/saveEvent", "url_expanded"); //só aqui o video_id está disponível
        this.$router.push(path);
      })
      .catch(() => {
        // TODO: redirect to 404
      });
  }
};
</script>
